import React, { useEffect, useState } from "react"
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, Row } from "reactstrap"
import { useTranslation } from "react-i18next"
import { useResponse } from "../../../hooks/useResponse"
import { sendInternalPayslipesEmail } from "../../../api/internalPayslips"
import ResultHandler from "../../../components/ResultHandler"

const SendPayslipesMailModal = ({handleClose, isOpen, payslipes, onSucess}) => {
  const { t } = useTranslation()
  const [msg, setMsg] = useState(null)
  const [uniqueAdmins, setUniqueAdmins] = useState([]);
  const [finalPayslipes, setFinalPayslipes] = useState([]);
  
  useEffect(() => {
    const payslipesByAdmin = {}
    const admins = [];

    payslipes.forEach(payslip => {
      const adminId = payslip.admin_id
      const admin = payslip.admin

      if(!payslipesByAdmin[adminId]) {
        payslipesByAdmin[adminId] = { adminId, payslipeIds: [] }
        admins.push(admin);
      }

      payslipesByAdmin[adminId].payslipeIds.push(payslip.id)
    });
    
    setFinalPayslipes(Object.values(payslipesByAdmin))
    setUniqueAdmins(admins);
  },[payslipes])

  // no
  const {loading, error, setData} = useResponse(sendInternalPayslipesEmail, () => {
    handleClose()
    onSucess()
    setMsg("")
    setFinalPayslipes([])
  })
  function handleSendEmail(){
    const data = {msg, emails: finalPayslipes}
    setData({type: "add", data})
  }

  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered={true}>
      <ModalBody className="py-5 px-5">
        <Row>
          <Col lg={12}>
            <div className="text-center mb-4">
              <h2>Send Via Email</h2>
            </div>
          </Col>
        </Row>
        
        <Row className="mb-3">
          <Col md={12}>
            <FormGroup>
                <Label>Message:</Label>
                <Input type="text" placeholder="write a message" value={msg} onChange={(e) => setMsg(e.target.value)} />
            </FormGroup>
          </Col>
        </Row>

        {uniqueAdmins.map((admin, idx) => {
            return (
              <div key={admin.id} className="mb-4">
                <h6>Admin #{idx+1}:</h6>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-1">
                  <span>Username: {admin?.username}</span>
                  <span>Payslipes Number: {finalPayslipes.find(p => p.adminId == admin.id)?.payslipeIds.length}</span>
                </div>
              </div>
            )
          })
        }
          
          {/* <ResultHandler error={error} /> */}

        <Row>
          <Col>
            <div className="text-center mt-4">
              {!loading && <Button
                onClick={handleSendEmail}
                color="primary"
                size="lg"
                style={{marginRight: "20px"}}
              >
                Send
              </Button>}
              {loading && <Button
                color="dark"
                size="lg"
                style={{marginRight: "20px"}}
              >
                Wait...
              </Button>}
              <Button
                onClick={handleClose}
                color="dark"
                size="lg"
              >
                {t("btns.Cancel")}
              </Button>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default SendPayslipesMailModal
